export default "<div class=\"full-height vh-100\">\r\n  <router-outlet></router-outlet>\r\n</div>\r\n"